// extracted by mini-css-extract-plugin
export var compact = "_ms-2";
export var phoneFrame = "_ms-0";
export var phoneScreen = "_ms-1";